import { LinkAuthenticationElement } from '@stripe/react-stripe-js';
import styles from './CheckoutStep.module.scss';

export interface LinkEmailCardProps {
  /** the email registration already captured, so nobody retypes what we asked for two screens ago */
  email: string;
  onChange: (email: string) => void;
}

/**
 * The email field, backed by Stripe Link.
 *
 * Its value is that Link recognises a returning Stripe shopper from the address they enter and offers
 * their saved card and shipping address, which is the fastest possible path through this screen.
 *
 * Prefilled from registration via `defaultValues`, which is Stripe's supported way to have a returning
 * shopper recognised without retyping an address they gave us two screens ago. The shop passes no
 * options here, but it has no email to pass -- its shopper is anonymous at this point, and ours is not.
 *
 * The address entered here is Link's lookup key, not the account's email. The purchase sends the Fi
 * account's own email -- sending this one instead makes `stripeCheckoutEndpoint` log "used Stripe
 * checkout with a different email from their account" whenever the two differ, which they will for
 * anyone whose Link address is not their Fi address.
 *
 * Sits above the address card deliberately: Link's autofill populates the `AddressElement` in the same
 * Elements group, so it has to come first or the shopper confirms an address that is then replaced.
 *
 * Link must stay enabled on the `PaymentElement` for any of this to work: Stripe only runs the lookup
 * and OTP when Link can actually pay, so `wallets: { link: 'never' }` there turns this element into a
 * plain email input. Only the Link *express button* is suppressed, in the `ExpressCheckoutElement`.
 */
export default function LinkEmailCard({ email, onChange }: LinkEmailCardProps) {
  return (
    <div className={styles.card}>
      <div className={styles.sectionTitle}>Email</div>
      <LinkAuthenticationElement
        options={{ defaultValues: { email } }}
        onChange={(event) => onChange(event.value.email)}
      />
    </div>
  );
}
